import React, { useState, useEffect,Fragment } from 'react';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    Divider,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    InputAdornment,
    MenuItem,
    Grid,
    Box
} from "@material-ui/core";
import { addExpenseDialogCss } from './ExpensesDialogCss';
import CloseIcon from '@material-ui/icons/Close';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import { connect } from "react-redux";
import DateFnsUtils from '@date-io/date-fns';
import { addVendorExpense,addExpenseV1,editExpenseV1,  getVehicleListV2,
} from '../../../store/actions/tripActionCreator';
import S3Uploader from '../s3Uploader/s3Uploader';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import DriverNameSelect from '../DriverDialogs/DriverNameSelect';
import { ExpenseTypeReceiptIcon,AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import * as logger from '../../../logger';
import { getTripDateFilterValues,isEmpty, numberWithCommas, replaceCommas, checkNumberOnly,decodeHtml,findArrayObject } from '../../../utils/utils';
import { updateVehicle3, singleTruck, PandL, Expenses, DriverExpenseType, AddExpenseTypeDriver, UpdateExpenseDetails, DeletePhotoAttachments } from '../../../store/actions/vehicleActionCreator';
import NotesIcon from '@material-ui/icons/Notes';
import AmountInput from '../Inputs/AmountInput';
import { trackDwebEvent } from '../../analytics';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
import { debounce } from 'lodash';
import { Waypoint } from "react-waypoint";
import AddShop from '../../pages/Shops/AddShop';
import { shopListForSelection } from '../../../store/actions/userActionCreators';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import AddNewExpense from '../../pages/Expenses/AddNewExpense';
import { getAllTripExpenseTypes,processVehicleExpenses,selectedJourney } from '../../../store/actions/expensesActionCreators';
import AddVehicle from '../../pages/Vehicles/AddVehicle';
import { TruckIcon } from '../../../components/icons';
import moment from 'moment';
import TripSelectionDialog from './TripSelectionDialog';
import JourneyTripRouteCardWithRouter from '../../pages/Trips/ViewJourney/JourneyTripRouteCard';
import { updateJourney,getJourneyDetails } from '../../../store/actions/tripActionCreator';
import { sendSucces } from '../../../utils/utils';
const AddTripExpenseDialog = ({ 
    open, 
    onClose, 
    vehicle,
    expenses,
    user,
    dispatchUpdateExpenseDetails, 
    dispatchPhotoAttachmentDelete, 
    onConfirm, 
    dispatchAddExpenseTypeDriver, 
    dispatchUpdateVehicleNew, 
    dispatchGetSingleTruck, 
    dispatchGetPandL, 
    dispatchGetTripExpenses, 
    dispatchGetAllTripExpense, 
    dispatchAddExpenseTypeMaintenance, 
    dispacthAddExpenses, 
    edit, 
    expenseData,
    dispatchAddExpenseV1,
    dispatchEditExpenseV1,
    dispatchGetShopList,
     expenseId,
     dispatchGetVehicleListAction,
     dispatchSelectJourney,
     dispatchUpdateJourney,
     dispatchGetJourney,
     trip
    }) => {

    let submit;
    let vehicleVal =expenseId&& expenseData && expenseData.vehicle && expenseData.vehicle.vehicleId ? expenseData.vehicle : null;
    const [dialogOpen, setDialogOpen] = useState(open);
    const [formError, setFormError] = React.useState(false);
    const [addDriverDialog, setAddDriverDialog] = useState(false);
    const [paidByDriverValue, setPaidByDriverValue] = useState(false);
    const [addExpensePhoto, setAddExpensePhoto] = useState(expenseData && expenseData.attachments ? expenseData.attachments : []);
    const [tripAllExpenseTypes, setTripAllExpenseTypes] = useState([]);
    const [expenseTypeValue, setExpenseTypeValue] = useState({ display: expenseData && expenseData.expenseName ? expenseData.expenseName : "" });
    const [expenseDate,setExpenseDate] = useState(expenseData && expenseData.expenseDate ? new Date(expenseData.expenseDate * 1000) : new Date())
    const [expenseTypeOpen, setExpenseTypeOpen] = useState(false);
    const [driverNameValue, setDriverNameValue] = useState("");
    const [amountValue, setAmountValue] = useState("");
    const [expenseAddToPartyBill, setExpenseAddToPartyBill] = React.useState(false);
    const [expenseBillableAmount, setExpenseBillableAmount] = React.useState('');
    const [expensePaymentMethod, setExpensePaymentMethod] = React.useState('cash');
    const [expenseTransactionId, setExpenseTransactionId] = React.useState('');
    const [expenseJourney, setExpenseJourney] = React.useState(null);
    const [expenseTrip, setExpenseTrip] = React.useState(null);
    const [tripSelectionDialog,setTripSelectionDialog] = React.useState(false);
    const [shopsListData, setShopsListData] = React.useState(null);
    const [shops, setShops] = React.useState([]);
    const [expenseShop, setExpenseShop] = React.useState(null);
    const [shopInputValue, setShopInputValue] = React.useState('');
    const [currentPageNo,setCurrentPageNo]  = useState(1);
    const [currentPageSize,setCurrentPageSize]  = useState(10);
    const [addShopOpen, toggleAddShopOpen] = React.useState(false);
    const [shopDialogValue, setShopDialogValue] = React.useState({
        name: ''
    });
    const [addExpenseOpen, toggleAddExpenseOpen] = React.useState(false);
    const [expenseDialogValue, setExpenseDialogValue] = React.useState({
        name: ''
    });
    const handleAddExpenseClose = () => {
        setExpenseDialogValue({
        name: '',
        });
        toggleAddExpenseOpen(false);
    };
    const handleExpenseSave = (status, response) => {
        toggleAddExpenseOpen(false);
        setExpenseTypeValue(response)
        dispatchGetAllTripExpense(
            (data) => {
                if (data.status && data.status.code == 200) {
                    //setTripAllExpenseTypes(data.response);
                }
            },
            () => {
            }
        );
    }
    const handleAddShopClose = () => {
        setShopDialogValue({
        name: '',
        });
        toggleAddShopOpen(false);
    };
    const handleShopSave = (status, response) => {
        toggleAddShopOpen(false);
        fetchShops()
        setExpenseShop(response && response.id ? response : null);
    }
    const onSearchBlur = debounce(query => {
        setCurrentPageNo(defaultPageNo)
        fetchShops(query,false)
      }, user && user.configs && user.configs.dwebSearchBebounceMs?parseInt(user.configs.dwebSearchBebounceMs):defaultDebounceMs);
      const fetchShops = (search,pagination)=>{
          let req = {
            pageSize:defaultPageSize,
            pageNo:defaultPageNo,
          }
          if(pagination){
            req.pageNo = currentPageNo+1
          }
          if(search){
            req.search=search;
          }
          dispatchGetShopList(req,(res)=>{
            if(res && res.status && res.status.code && res.status.code == 200 && res.response){
              setShopsListData(res.response)
              if(pagination){
                setShops([...shops,...res.response.shops])
              }else{
                setShops(res.response.shops)
              }
            }
          },()=>{

          })
    }
    useEffect(() => {
        if (expenseData && expenseData.id) {
            if(expenseData.tripInfo&& expenseData.tripInfo.journeyId){
              dispatchGetJourney(expenseData.tripInfo.journeyId,(res)=>{
                if (res && res.status && res.status.code == 200) {
                  setExpenseJourney(res.response)
                  if(expenseData.paymentMethod){
                    setExpensePaymentMethod(expenseData.paymentMethod)
                  }
                  if(expenseData.billable){
                    setExpenseAddToPartyBill(true)
                  }
                  if(expenseData.billable && expenseData.billableAmount){
                    setExpenseBillableAmount(numberWithCommas(expenseData.billableAmount))
                  }
                  if(expenseData.billable && expenseData.billableAmount && expenseData.tripInfo.tripId && res.response && res.response.trips){
                    let trip = findArrayObject('id',expenseData.tripInfo.tripId,res.response.trips);
                    setExpenseTrip(trip)
                  }
                  if(expenseData.paymentMethod && expenseData.paymentMethod == 'credit' && expenseData.shopId && expenseData.shopName){
                      setExpenseShop({
                          id:expenseData.shopId,
                          name:expenseData.shopName
                      })
                  }
                  if(expenseData.paymentMethod && expenseData.paymentMethod == 'online' && expenseData.paymentData){
                      setExpenseTransactionId(expenseData.paymentData)
                  }
                }
              });
            }
        }
    }, [open,expenseTypeValue, expenseData]);
    useEffect(()=>{
        let active = true;
        if(shopInputValue ===''){
          return undefined;
        }
        return()=>{
          active = false
        }
    },[shopInputValue])
    useEffect(()=>{
      if(expensePaymentMethod && expensePaymentMethod == 'credit'){
        //fetchShops()
      }
      if(expensePaymentMethod && expensePaymentMethod == 'paid_by_driver'){
        handlePaidByDriver()
      }
    },[expensePaymentMethod])

    let singleTruck = vehicle.singleTruck;
    let truckBook = vehicle.truckBooks;

    const filter = createFilterOptions();

    const classes = addExpenseDialogCss();


    useEffect(() => {

        dispatchGetAllTripExpense(
            (data) => {
                logger.log("Add Truck Expense", "Get vehicle expense type successfull");
                if (data.status && data.status.code == 200) {
                    //setTripAllExpenseTypes(processVehicleExpenses(data.response).payload);
                }
            },
            () => {
                logger.log("Add Truck Expense", "Get Vehicle Expense Type Failed");
            }
        );

    }, [open]);
    useEffect(() => {
      if (expenses.selectedJourney) {
          //setExpenseJourney(expenses.selectedJourney);
      }
  }, [expenses.selectedJourney]);
    const initialValues = {
        paidByDriver: paidByDriverValue,
        amount: amountValue ? amountValue : expenseData && expenseData.amount ? numberWithCommas(expenseData.amount) : "",
        expenseType: expenseTypeValue && expenseTypeValue.display ? expenseTypeValue : "",
        expenseDate: expenseDate ? expenseDate : new Date(),
        notes: expenseData && expenseData.description ? expenseData.description : "",
        paymentMethod:expensePaymentMethod,
        transactionId:expenseTransactionId,
        shop:expenseShop,
        journey:expenseJourney,
        addToPartyBill: expenseAddToPartyBill,
        partyBillableAmount: expenseBillableAmount,
        addToPartyBillTrip:expenseTrip,
    }

    const handleAddExpensePhoto = (file) => {
        var newPhoto = [...addExpensePhoto];
        newPhoto.push({ s3Link: file });
        setAddExpensePhoto(newPhoto);
    }

    const handleDeleteExpensePhoto = (index, attachId) => {
        var newPhoto = [...addExpensePhoto];
        newPhoto.splice(index, 1);
        setAddExpensePhoto(newPhoto);

        if (attachId) {
            dispatchPhotoAttachmentDelete(
                expenseId,
                attachId,
                () => {
                    logger.log("Add Fuel Expense Dialog", "Attachment deleted successfully");
                },
                () => {
                    logger.log("Add Fuel Expense Dialog", "Attachment delete failed");
                },
            )
        }
    }

    const handlePaidByDriver = (value) => {
        setPaidByDriverValue(!paidByDriverValue);
        if (expenseJourney && (!expenseJourney.driver || expenseJourney.driver && !expenseJourney.driver.driverId)) {
            setAddDriverDialog(true);
        }
    }

    const handleAddDriverDialogClose = () => {
        setAddDriverDialog(false);
        setExpensePaymentMethod('cash');
    }

    const handleClose = () => {
        setDialogOpen(false);
        dispatchSelectJourney(null)
        onClose();
    }

    const handleAddDriverSubmit = (driverIdValue) => {
        var data = {
            driverId: driverIdValue
        }
        dispatchUpdateJourney(
          expenseJourney&&expenseJourney.id?expenseJourney.id:'',
            data,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                  dispatchGetJourney(expenseJourney&&expenseJourney.id?expenseJourney.id:'',(res)=>{
                    if (res && res.status && res.status.code == 200) {
                      setExpenseJourney(res.response)
                      logger.log("Add Driver Dialog", "Update Vehicle successfull");
                      setAddDriverDialog(false);
                      setExpensePaymentMethod('paid_by_driver')
                    }
                  })   
                }
            },
            () => {
                logger.log("Add Driver Dialog", "Update Vehicle failed");
            }
        );
    }

    const validate = values => {
        const errors = {}
        if(values){
            if(errors.noValues){
              delete errors['noValues'];
            }
            if (!values.expenseType) {
                errors.expenseType = "Please select expense type."
            }
            if (!values.journey) {
                errors.journey = "Please select a Trip"
            }
            if (!values.amount || !checkNumberOnly(replaceCommas(values.amount))) {
                errors.amount = "Please enter valid amount."
            }
            if (!values.expenseDate) {
                errors.expenseDate = "Please select expense date"
            }
            if(!values.paymentMethod){
                errors.paymentMethod = 'Please Select a Payment Mode';
            }
            if(values && values.paymentMethod && values.paymentMethod =='credit' && !values.shop){
                errors.shop = 'Please Select a shop';
            }
            if (values.addToPartyBill && !values.addToPartyBillTrip) {
              errors.addToPartyBillTrip = 'Please Select a Trip';
            }
            if (values.addToPartyBill && !values.partyBillableAmount) {
              errors.partyBillableAmount = 'Please Enter a Billable Amount';
            }
            if (values.addToPartyBill && values.partyBillableAmount && !checkNumberOnly(replaceCommas(values.partyBillableAmount))) {
              errors.partyBillableAmount = 'Invalid Amount';
            }
            if (values.addToPartyBill && values.partyBillableAmount && checkNumberOnly(replaceCommas(values.partyBillableAmount)) && Number(replaceCommas(values.partyBillableAmount)) <= 0) {
              errors.partyBillableAmount = 'Amount cannot be zero or negative';
            }
        }else{
            errors.noValues = "novalues"
        }

        return errors
    }

    const onSubmit = values => {

        const fleetOwnerIdValue = user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "";
        let splitted = ''
        if(values && values.expenseType && values.expenseType.display){
          splitted = (values.expenseType.display.replace(/\'/g, "")).split(" ");
        }else{
          splitted = values && values.expenseType ? (values.expenseType.replace(/\'/g, "")).split(" ") : [];
        }
        let {
            addToPartyBill,
            partyBillableAmount,
            addToPartyBillTrip,
            paymentMethod,
            shop,
            transactionId
           } = values;

        let value = "";
        
        splitted.forEach((splittedString) => {
            value += splittedString.charAt(0).toUpperCase() + splittedString.slice(1) + " ";
        });

        var expenseValue = value.trim();
        let allExpenseTypes = expenses && expenses.allTripExpenseTypes ? expenses.allTripExpenseTypes : []
        let index = allExpenseTypes.findIndex(x => x.display === expenseValue);
        let expenseTypeSelectedValue = allExpenseTypes && allExpenseTypes[index] && allExpenseTypes[index].value ? allExpenseTypes[index].value : "";
        if(!expenseTypeSelectedValue && expenseData && expenseData.expenseType){
          expenseTypeSelectedValue = expenseData.expenseType
        }
        var reqData = {
            vehicleId:expenseJourney&&expenseJourney.vehicle&&expenseJourney.vehicle.vehicleId ? expenseJourney.vehicle.vehicleId :expenseJourney&&expenseJourney.vehicle&& expenseJourney.vehicle.id?expenseJourney.vehicle.id:'',
            journeyId:expenseJourney&&expenseJourney.id ? expenseJourney.id : "",
            fleetOwnerId: fleetOwnerIdValue,
            amount: replaceCommas(values.amount),
            expenseDate: Math.round((values.expenseDate.setHours(0, 0, 0, 0) / 1000)),
            attachments: addExpensePhoto,
            type:expenseValue&&expenseValue=='Other Expense'?'Others':expenseTypeSelectedValue,
            description: values.notes,
            paymentMethod:paymentMethod,
            paidByDriver: values.paidByDriver,
        }
        if (addToPartyBill && partyBillableAmount && addToPartyBillTrip) {
          reqData['billable'] = true;
          reqData['isBillable'] = true;
          reqData['billableAmount'] = Number(replaceCommas(partyBillableAmount));
          reqData['tripId'] = expenseTrip&&expenseTrip.id?expenseTrip.id:addToPartyBillTrip;
        }else{
          reqData['billable'] = false;
          reqData['isBillable'] = false;
          reqData['tripId'] = null;
        }
        if (paymentMethod && paymentMethod == 'online' && transactionId) {
          reqData['paymentData'] = transactionId;
        }else{
          reqData['paymentData'] = null;
        }
        if (paymentMethod && paymentMethod == 'paid_by_driver') {
          reqData['paidByDriver'] = true;
        }
        if (paymentMethod && paymentMethod == 'credit' && shop && shop.id) {
          reqData['shopId'] = shop.id;
        } else {
            reqData['shopId'] = null;
        }
        /*if (values.paidByDriver) {
            expenseData.paidByDriver = values.paidByDriver;
        }*/
        let returnDate = expenseJourney&&expenseJourney.id&&expenseJourney.trips&&expenseJourney.trips[0]&&expenseJourney.trips[0].startDate?expenseJourney.trips[0].startDate:0
        if (edit) {
            dispatchEditExpenseV1(
                expenseId,
                reqData,
                (data) => {
                    if (data.status && data.status.code == 200) {
                        logger.log("Add Fuel Expense Dialog Dweb", "Update expense successfull");
                        sendSucces("Trip Expense Updated Successfully!")
                        setDialogOpen(false);
                        dispatchSelectJourney(null)
                        onConfirm(moment(Number(returnDate)*1000).format('MMM-YYYY'));
                    }
                },
                () => {
                    logger.log("Add Fuel Expense Dialog Dweb", "Update expense failed");
                }
            );
        } else {
            dispatchAddExpenseV1(reqData,
                (data) => {
                    if (data.status && data.status.code == 200) {
                        sendSucces("Trip Expense added Successfully!")
                        setDialogOpen(false);
                        dispatchSelectJourney(null)
                        onConfirm(moment(Number(returnDate)*1000).format('MMM-YYYY'));
                        /*trackDwebEvent("Dweb SVP Other Expenses Expense Created Successfully", {
                            vehicle_id: data && data.response && data.response.vehicleId ? data.response.vehicleId : "",
                            vehicle_number: truckBook.vehicleNumber ? truckBook.vehicleNumber : "",
                            total_other_expense: truckBook.totalCost ? truckBook.totalCost : "",
                            expense_amount: data && data.response && data.response.amount ? data.response.amount : "",
                            expense_id: data && data.response && data.response.id ? data.response.id : "",
                        });*/
                    }
                },
                () => {
                    logger.log("Single Vehicle Add Maintenance Dialog", "Add expense failed");
                }
            );
        }
    }
    const handleSeclectTrip= ()=>{
      setTripSelectionDialog(true);
    }
    const handleChangeDriver= ()=>{
      if (expenseJourney && expenseJourney.driver && expenseJourney.driver.driverId && expenseJourney.driver.driverName) {
        setDriverNameValue({ name: expenseJourney.driver.driverName, id:  expenseJourney.driver.driverId });
        setAddDriverDialog(true);
      }
    }
    const handleTripSelectionClose = ()=>{
      setTripSelectionDialog(false)
    }
    const handleTripSelectionConfirm = (journey)=>{
      setTripSelectionDialog(false);
      setExpenseJourney(journey);
      setExpensePaymentMethod('cash');
    }
    const getFormFields = (values) => {
      let startDate = expenseJourney&&expenseJourney.id&&expenseJourney.trips&&expenseJourney.trips[0]&&expenseJourney.trips[0].startDate?new Date(Number(expenseJourney.trips[0].startDate)*1000):null
        return [
            {
                size: 12,
                visible: expenses && expenses.allTripExpenseTypes && expenses.allTripExpenseTypes.length > 0 ? true : false,
                field: (
                    <>
                        <div className={classes.titleV1} >Expense Type*</div>
                        <Autocomplete
                            classes={{
                                listbox: classes.listBoxAutoCompelete,
                                option: classes.listBoxOption,
                                input: classes.textTransformCaptialize
                            }}
                            id="select-trip-expense-type"
                            name="expenseType"
                            size="small"
                            required={true}
                            placeholder="Expense Type"
                            groupBy={(option) => option.mapper}
                            filterSelectedOptions
                            value={expenseTypeValue}
                            onChange={(event, newValue) => {

                                let newTypeValue = newValue ? newValue.toString() : "";
                                if (typeof newValue === 'string') {
                                    // timeout to avoid instant validation of the dialog's form.
                                    setTimeout(() => {
                                      setExpenseTypeValue('');
                                      toggleAddExpenseOpen(true);
                                      setExpenseDialogValue({
                                        name: newValue ? newValue.replace(/\"/g, "") : "",
                                      });
                                    });
                                } else if (newValue && newValue.inputValue) {
                                    setExpenseTypeValue(null);
                                    toggleAddExpenseOpen(true);
                                    setExpenseDialogValue({
                                      name: newValue.inputValue ? newValue.inputValue.replace(/\"/g, "") : "",
                                    });
                                } else if (newValue && newValue.inputValue === '') {
                                    setExpenseTypeValue('');
                                    toggleAddExpenseOpen(true);
                                    setExpenseDialogValue({
                                      name: "",
                                    });
                                }else {
                                    setExpenseTypeValue(newValue);
                                  }
                            }}
                            getOptionSelected={(option, value) => option.value === value.value}
                            autoHighlight
                            options={expenses && expenses.allTripExpenseTypes ? expenses.allTripExpenseTypes : []}
                            clearOnBlur
                            getOptionValue={option => option.display}
                            getOptionLabel={(option) => {
                                // e.g value selected with enter, right from the input
                                let value = option.display ? option.display.replace(/\"/g, "") : "";
                                if (typeof option === 'string') {
                                    // setExpenseTypeValue(option);
                                    return value;
                                }
                                if (option) {
                                    // setExpenseTypeValue(option);
                                    return value;
                                }
                                // setExpenseTypeValue(option);

                                return value;
                            }}
                            disableCloseOnSelect={false}
                            filterOptions={(options, params) => {

                                const filtered = filter(options, params);
                                filtered.unshift({
                                    inputValue: params.inputValue,
                                    display: params.inputValue&&params.inputValue.length>0?`"${params.inputValue}"`:'',
                                    add:true
                                });
                                return filtered;

                            }}
                            renderOption={(option, params) => {
                                if (option && option.add) {
                                    return (
                                        <>
                                            <div className={classes.newExpenseTypeV1}>
                                                <div className={classes.newExpenseTypeV2}>
                                                    <ExpenseTypeReceiptIcon className={classes.fontSize18} />
                                                    <div className={classes.divV6}>{params.inputValue&&params.inputValue.length>0?'Add Custom Expense called':'Add Custom Expense'}</div>
                                                    <div className={classes.capitalize}>{option.display}</div>
                                                </div>
                                                <ChevronRightIcon className={classes.cherveRightIcon} />
                                            </div>
                                        </>
                                    );
                                } else {
                                    return (
                                        <div className={classes.divExpenseName}>
                                            {option.display}
                                        </div>
                                    );
                                }
                            }}
                            textFieldProps={
                              {
                                placeholder: "Expense Type",
                                variant: "outlined",
                                margin: 'none',
                                className:classes.divMargin
                              }
                            }
                            multiple={false}
                        />
                    </>
                ),
            },
            {
                size: 12,
                visible: edit?false:true,
                field: (
                    <>
                        {expenseJourney&&expenseJourney.id?<Box className={classes.journeyBox}>
                          <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                              <Typography className={classes.customerName}>{
                                expenseJourney&&expenseJourney.trips&&expenseJourney.trips[0]&&expenseJourney.trips[0].customer
                                &&expenseJourney.trips[0].customer.customerName?expenseJourney.trips[0].customer.customerName:'-/-'
                                }
                              </Typography>
                              <Typography className={classes.vehicleNumber}>{
                                 expenseJourney&&expenseJourney.trips&&expenseJourney.vehicle&&expenseJourney.vehicle.vehicleNumber?expenseJourney.vehicle.vehicleNumber:'-/-'
                              }</Typography>
                          </Box>
                          <JourneyTripRouteCardWithRouter
                              viewBox={true}
                              destination={expenseJourney&&expenseJourney.trips&&expenseJourney.trips[0]&&expenseJourney.trips[0].destinationLocation ? expenseJourney.trips[0].destinationLocation : ''}
                              source={expenseJourney&&expenseJourney.trips&&expenseJourney.trips[0]&&expenseJourney.trips[0].startLocation ? expenseJourney.trips[0].startLocation : ''}
                              startDate={expenseJourney&&expenseJourney.trips&&expenseJourney.trips[0]&&expenseJourney.trips[0].startDate ? expenseJourney.trips[0].startDate : ''}
                              completedDate={expenseJourney&&expenseJourney.trips&&expenseJourney.trips[0]&&expenseJourney.trips[0].completedDate ? expenseJourney.trips[0].completedDate : ''}
                            />
                            <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                                <Button variant="contained" className={classes.changeTripButton} onClick={() => handleSeclectTrip()} >
                                  Change Trip
                                </Button>
                                {expenseJourney&&expenseJourney.trips && expenseJourney.trips.length>1&&<Box display={'flex'} alignItems={'center'} className={classes.loadCountBox}>
                                  +{expenseJourney.trips.length-1} more loads
                                </Box>}
                            </Box>
                        </Box>:<div className={classes.marginV2}>
                          <Button variant="contained" className={classes.addTripButton} onClick={() => handleSeclectTrip()} >
                              Select Trip
                          </Button>
                        </div>}
                    </>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Amount Paid*</div>
                            <AmountInput
                                placeholder="Amount Paid"
                                name="amount"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setAmountValue(e.target.value)}
                                fieldProps={{
                                    // parse: value => value && numberWithCommas(value)
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                                }}
                                className={classes.marginV1}
                            />
                        </div>
                    </>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Expense Date*</div>
                            <DatePicker
                                disableFuture
                                name="expenseDate"
                                margin="none"
                                variant="inline"
                                minDate={startDate}
                                fullWidth={true}
                                onChange={(date) => { setExpenseDate(date) }}
                                inputVariant="outlined"
                                size="small"
                                format="dd-MM-yyyy"
                                placeholder="Select Date"
                                dateFunsUtils={DateFnsUtils}
                                className={classes.marginV1}
                                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                            />
                        </div>
                    </>
                ),
            },
            {
              size: 12,
              visible: true,
              inline: false,
              field: (
                <>
                  {/* <div className={classes.divTripV2}>Billing Information</div> */}
                  <div className={classes.marginV2}>
                  <div className={classes.title}>Payment Mode*</div>
                  <Radios
                    //label="Payment Mode"
                    name="paymentMethod"
                    required={true}
                    formControlProps={{
                      margin: 'none',
                      className: classes.billingTypeRadio,
                      fullWidth: true
                    }}
                    formControlLabelProps={{
                      className: classes.billingTypeLabel
                    }}
                    className={classes.mtV2}
                    onChange={(e) => {setExpensePaymentMethod(e.target.value)}}
                    formLabelProps={{}}
                    radioGroupProps={{ row: true }}
                    data={expenseJourney && expenseJourney.id?[
                      { value: 'cash', label: 'Cash' },
                      { value: 'credit', label: 'Credit' },
                      { value: 'paid_by_driver', label: 'Paid By Driver' },
                      { value: 'online', label: 'Online' }
                    ]:[
                      { value: 'cash', label: 'Cash' },
                      { value: 'credit', label: 'Credit' },
                      { value: 'online', label: 'Online' }
                    ]}
                  />
                  </div>
                </>
              ),
            },
            {
              size: 12,
              visible:values && values.paymentMethod && values.paymentMethod=='credit'?true:false,
              field: (<Autocomplete
                required={true}
                id="search-shop-input"
                onOpen={()=>{
                  fetchShops()
                }}
                //getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                options={shops}
                autoComplete
                name="shop"
                //includeInputInList
                filterSelectedOptions
                size="small"
                //disableClearable
                value={expenseShop}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                    // timeout to avoid instant validation of the dialog's form.
                    setTimeout(() => {
                      setExpenseShop('');
                      toggleAddShopOpen(true);
                      setShopDialogValue({
                        name: newValue ? newValue : "",
                      });
                    });
                  } else if (newValue && newValue.inputValue) {
                    setExpenseShop(null);
                    toggleAddShopOpen(true);
                    setShopDialogValue({
                      name: newValue.inputValue ? newValue.inputValue : "",
                    });
                  } else if (newValue && newValue.inputValue === '') {
                    setExpenseShop('');
                    toggleAddShopOpen(true);
                    setShopDialogValue({
                      name: "",
                    });
                  } else {
                    setExpenseShop(newValue && newValue.id ? newValue : null);
                  }
                }}
                filterOptions={(options, params) => {
                  let filtered =[]
                  options.forEach((item,index)=>{
                    filtered.push({
                      ...item,
                      index:index
                    })
                  });
                    filtered.unshift({
                        inputValue: params.inputValue,
                        name: params.inputValue && params.inputValue.length > 1 ? `Add "${params.inputValue}" as Shop` : `Add New Shop`,
                        add: true
                    });
                  return filtered;
                }}
                clearOnBlur
                multiple={false}
                getOptionValue={option => option}
                getOptionLabel={(option) => {
                  // e.g value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return '';
                  }
                  if (option.inputValue || !option.id) {
                    return '';
                  }
                  return option && option.name ? option.name : ''
                }}
                onInputChange={(event, newInputValue) => {
                  setShopInputValue(newInputValue);
                  onSearchBlur(newInputValue,false)
                }}
                classes={
                    {
                      option:classes.shopOption
                    }
                  }
                textFieldProps={
                  {
                    label: "Shop",
                    placeholder: "Search and select shop",
                    variant: "outlined",
                    margin: 'normal',
                  }
                }
                renderOption={(option, { selected, inputValue }) => {
                  let matchesName, matchesNumber;
                  let partsName, partsNumber;
                  matchesName = match(option.name, inputValue);
                  partsName = parse(option.name, matchesName);
                  matchesNumber = match(option.contactNumber, inputValue);
                  partsNumber = parse(option.contactNumber, matchesNumber);

                  if (option && option.id) {
                    if (option.index == shops.length-1) {
                      return (
                        <Fragment>
                          <Waypoint
                            onEnter={() => {
                              if(!shopInputValue && shopsListData && shopsListData.maxPage && shopsListData.maxPage != currentPageNo){
                                setCurrentPageNo(currentPageNo+1)
                                fetchShops(option.inputValue,true)
                              }
                            }}
                          />
                         <div className={classes.shopListItem}>
                            {partsName.map((part, index) => {
                              return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                {part.text}
                              </span>
                              )
                            })}
                            {option.contactNumber && <>
                              <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                              {partsNumber.map((part, index) => {
                                return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                                  {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                                </span>
                                )
                              })}
                            </>}
                          </div>
                        </Fragment>
                      );
                    } else {
                      return (
                        <div className={classes.shopListItem}>
                        {partsName.map((part, index) => {
                          return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                            {part.text}
                          </span>
                          )
                        })}
                        {option.contactNumber && <>
                          <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                          {partsNumber.map((part, index) => {
                            return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                              {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                            </span>
                            )
                          })}
                        </>}
                      </div>
                      );
                    }
                  } else {
                    return (
                      <div className={classes.shopListItem1}>
                        <AddPersonIcon className={classes.addPersonIcon} />
                        {partsName.map((part, index) => {
                          return (<span key={index} style={{ color: index == 0 ? '#0033cc' : 'black' }}>
                            {part.text}
                          </span>
                          )
                        })}
                        <ChevronRightIcon className={classes.cherveRightIcon} />
                      </div>
                    );
                  }

                }}
                />)
            },
            {
              size: 12,
              visible: values && values.paymentMethod && values.paymentMethod=='online'?true:false,
              field: (
                <TextField
                  label={'Transaction ID'}
                  placeholder="Transaction ID"
                  name="transactionId"
                  variant="outlined"
                  size="small"
                  margin="normal"
                  onChange={(e) => { setExpenseTransactionId(e.target.value) }}
                />
              ),
            },
            {
              size: 12,
              visible: values && values.paymentMethod && values.paymentMethod=='paid_by_driver'?true:false,
              field: (
                <>
                <TextField
                  label={'Driver'}
                  placeholder="Driver"
                  name="selectedDriver"
                  variant="outlined"
                  size="small"
                  disabled
                  value={expenseJourney && expenseJourney.driver&& expenseJourney.driver.driverId && expenseJourney.driver.driverName ? expenseJourney.driver.driverName : ''}
                  margin="normal"
                />
                {!expenseId && expenseJourney && expenseJourney.driver&& expenseJourney.driver.driverId && <Button variant="contained" className={classes.changeDriverButton} onClick={() => handleChangeDriver()} >
                      Change Driver
                </Button>}
                </>
              ),
            },
            {
              size: 12,
              visible: expenseJourney && expenseJourney.id?true:false,
              field: (<Checkboxes
                size='small'
                margin='normal'
                fullWidth={true}
                formControlProps={{
                  className: classes.switchControl1
                }}
                onChange={(e, value) => {
                  setExpenseAddToPartyBill(value)
                  if(values.amount){
                    setExpenseBillableAmount(values.amount)
                  }
                  if(expenseJourney && expenseJourney.trips && expenseJourney.trips.length==1 && expenseJourney.trips[0]){
                    setExpenseTrip(expenseJourney.trips[0]);
                  }
                }}
                formGroupProps={{}}
                formControlLabelProps={{
                  classes: {
                    root: classes.switchLabel
                  },
                  labelPlacement: 'end',
                }}
                name="addToPartyBill"
                data={{ label: 'Add To Party Bill', value: true }} label="" />)
            },
            {
              size: 12,
              visible:expenseJourney && expenseJourney.id && values && values.addToPartyBill ? true : false,
              field: (
                <Autocomplete
                  id="select-party-trip-list"
                  name="addToPartyBillTrip"
                  size="small"
                  classes={{
                    listbox: classes.listBoxAutoCompelete,
                    option: classes.listBoxOption
                  }}
                  required={true}
                  autoHighlight
                  disabled={expenseJourney && expenseJourney.trips && expenseJourney.trips.length==1}
                  value={expenseTrip}
                  onChange={(event, newValue) => {
                    setExpenseTrip(newValue && newValue.id ? newValue : null);
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    return filtered;
                  }}
                  options={expenseJourney && expenseJourney.trips?expenseJourney.trips:[]}
                  handleHomeEndKeys
                  getOptionValue={option => option.id}
                  getOptionLabel={(option) => {
                    if(option && option.customer && option.customer.customerName){
                      let label = `${option && option.customer && option.customer.customerName}&nbsp;&nbsp;&bull;&nbsp;&nbsp;`
                      if(option.startLocation && option.destinationLocation){
                        label += `${option.startLocation}-${option.destinationLocation}`
                      }
                      return decodeHtml(label)
                    }
                    return option && option.customer && option.customer.customerName ? option.customer.customerName : ''
                  }}
                  renderOption={(option, { selected, inputValue }) => {
                    let matchesName = match( option.customer.customerName, inputValue);
                    let partsName = parse( option.customer.customerName, matchesName);
                    if (option &&  option.customer && option.customer.customerName) {
                      return (
                        <div className={classes.expenseTypeListItem}>
                          {partsName.map((part, index) => {
                            return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                              {part.text}
                            </span>
                            )
                          })}
                          {option.startLocation && option.destinationLocation && <>
                            <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                            <span>{`${option.startLocation}-${option.destinationLocation}`}</span>
                          </>}
                        </div>
                      );
                    }
                  }}
                  textFieldProps={
                    {
                      label: "Select a Trip",
                      placeholder: "Select a Trip",
                      variant: "outlined",
                      margin: 'none',
                      name: "addToPartyBillTrip",
                    }
                  }
                  /*renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Expense Type"
                      placeholder="Select a Expense Type"
                      variant="outlined"
                      name="expense_type"
                      margin='normal'
                    />
                  )}*/
                  multiple={false}
                />
              ),
            },
            {
              size: 12,
              visible:expenseJourney && expenseJourney.id && values && values.addToPartyBill ? true : false,
              field: (
                <AmountInput
                  label={'Amount to be Added to Party Bill'}
                  placeholder="Amount"
                  name="partyBillableAmount"
                  variant="outlined"
                  size="small"
                  onChange={(e) => {
                    //numberWithCommasInput(e,setExpenseAmount)
                    setExpenseBillableAmount(e.target.value)
                  }}
                  fieldProps={{
                    parse: value => value && numberWithCommas(value)
                  }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                  }}
                  margin="normal"
                  required={true}
                />
              ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <div className={classes.title}>Notes</div>
                        <TextField
                            placeholder="Notes"
                            name="notes"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            multiline={true}
                            rows={3}
                            rowsMax={3}
                            className={classes.textNote}
                            InputProps={{
                                startAdornment: <InputAdornment position="start" className={classes.inputAdornmentV1}> <NotesIcon /></InputAdornment>
                            }}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                        >
                            {addExpensePhoto && addExpensePhoto.length > 0 &&
                                <Grid item>
                                    <div className="S3Uploader-image-margin">
                                        {addExpensePhoto && addExpensePhoto.map((expenseImage, index) => (
                                            <div className="S3Uploader-image-div" key={index}>
                                                {expenseImage.s3Link && <img className="S3Uploader-imagesrc" src={expenseImage.s3Link} alt="fileUpload" />}
                                                <img className="S3Uploader-imageclose" src={require("../../../assets/close-icon.svg")} onClick={() => { handleDeleteExpensePhoto(index, expenseImage.id) }}></img>
                                            </div>
                                        ))}
                                    </div>
                            </Grid>}
                            {addExpensePhoto && addExpensePhoto.length > 0?<Grid item>
                                <S3Uploader id='add-trip-expense-from-expenses-img-upload-with' toggle={true} directoryName={"dweb-images/Vehicle/AddTripExpense"} handleFile={handleAddExpensePhoto} />
                            </Grid>:<Grid item>
                                <S3Uploader id='add-trip-expense-from-expenses-img-upload-without' toggle={true} directoryName={"dweb-images/Vehicle/AddTripExpense"} handleFile={handleAddExpensePhoto} />
                            </Grid>}
                        </Grid>
                    </div>

                ),
            },
            {
                size: 12,
                visible:false, //handleDisplayPaidByDriver(values.expenseType),
                field: (
                    <div className={classes.divV4}>
                        <div className={classes.divV5}>Paid by {singleTruck && singleTruck.driverId && singleTruck.driverName ? singleTruck.driverName : 'Driver'}</div>
                        <Switches
                            size='small'
                            margin='normal'
                            formControlProps={{
                                className: classes.switchControl
                            }}
                            onChange={() => { handlePaidByDriver() }}
                            className={classes.switch}
                            name="paidByDriver"
                            data={{ label: '', value: true }} label="" />
                    </div>
                ),
            },
        ]
    }

    return (
        <>
            <Dialog fullWidth={true}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paper: classes.paper2, paperWidthSm: classes.paperWidth }}>
                <DialogTitle className={classes.dialogTitleV1}>
                    {edit &&
                        <div className={classes.divV1}>Edit Trip Expense</div>
                    }
                    {!edit &&
                        <div className={classes.divV1}>Add Trip Expense</div>
                    }
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Form
                        onSubmit={onSubmit}
                        validateOnBlur={true}
                        //keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit;
                            setFormError(isEmpty(validate(values)));
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>
                <Divider className={classes.marginV3} />
                <DialogActions className={classes.da1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button
                    className={!formError ? classes.disableCta : classes.saveCta}
                    disabled={!formError}
                    type="submit" variant="contained"
                        // onClick={() => {
                        //     document.getElementById('myForm')
                        //         .dispatchEvent(new Event('submit', { cancelable: true }))
                        // }}
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
            {addDriverDialog && <DriverNameSelect onOpen={addDriverDialog} onClose={handleAddDriverDialogClose} fromSingleTruck={true} onConfirm={handleAddDriverSubmit} driverDetail={driverNameValue} />}
            {addShopOpen && <AddShop open={addShopOpen} defaultName={shopDialogValue.name} defaultNumber={shopDialogValue.number} onClose={handleAddShopClose} onSave={handleShopSave} />}
            {addExpenseOpen && <AddNewExpense addType={'tripExpense'} open={addExpenseOpen} defaultName={expenseDialogValue.name} onClose={handleAddExpenseClose} onSave={handleExpenseSave} />}
            {tripSelectionDialog && <TripSelectionDialog open={tripSelectionDialog} onClose={handleTripSelectionClose} onConfirm={handleTripSelectionConfirm} />}
        </>
    )

}

const mapStateToProps = (state) => ({ vehicle: state.vehicle, user: state.user,expenses:state.expenses,trip:state.trip });
const mapDispatchToProps = (dispatch) => ({
    dispatchUpdateVehicleNew: (vehicleId, data, onSuccess, onFailure) => {
        dispatch(
            updateVehicle3(vehicleId, data, onSuccess, onFailure))
    },
    dispatchPhotoAttachmentDelete: (expenseId, attachId, onSuccess, onFailure) => dispatch(DeletePhotoAttachments(expenseId, attachId, onSuccess, onFailure)),
    dispatchUpdateExpenseDetails: (expenseId, data, onSuccess, onFailure) => dispatch(UpdateExpenseDetails(expenseId, data, onSuccess, onFailure)),
    dispacthAddExpenses: (data, onSuccess, onFailure) => dispatch(addVendorExpense(data, onSuccess, onFailure)),
    dispatchAddExpenseTypeDriver: (data, onSuccess, onFailure) => dispatch(AddExpenseTypeDriver(data, onSuccess, onFailure)),
    dispatchGetAllTripExpense: (onSuccess, onFailure) => dispatch(getAllTripExpenseTypes(onSuccess, onFailure)),
    dispatchGetSingleTruck: (truckId, onSuccess, onFailure) => dispatch(singleTruck(truckId, onSuccess, onFailure)),
    dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure)),
    dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
    dispatchAddExpenseV1: (request, onSuccess, onFailure) =>
    dispatch(addExpenseV1(request, onSuccess, onFailure)),
    dispatchGetShopList: (data,onSuccess, onError) => {
        dispatch(shopListForSelection(data,onSuccess, onError))
    },
    dispatchEditExpenseV1: (expenseId, request, onSuccess, onFailure) =>
    dispatch(editExpenseV1(expenseId, request, onSuccess, onFailure)),
    dispatchGetVehicleListAction: (data, onSuccess, onFailure) => dispatch(getVehicleListV2(data, onSuccess, onFailure)),
    dispatchSelectJourney: (data) => dispatch(selectedJourney(data)),
    dispatchUpdateJourney: (tripId, trip, onSuccess, onError) => {
      dispatch(updateJourney(tripId, trip, onSuccess, onError));
    },
    dispatchGetJourney: (tripId, onSuccess, onError) =>
    dispatch(getJourneyDetails(tripId, onSuccess, onError)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddTripExpenseDialog);
